import './AgentReply.css'
import { useEffect } from 'react'
import type { AgentWidget } from 'aevocam-rest-api-spec'
import { MarkdownViewer } from '@/components/scalar/MarkdownViewer'
import { AgentWidgetView } from './AgentWidgetView'

type Props = {
  content: string
  widgets?: AgentWidget[]
  reasoning?: string
  /** True when widgets just arrived from the live stream for this turn */
  fromStream?: boolean
  onStreamConsumed?: () => void
  setArticleIds?: (articleIds?: string[]) => void
}

export function AgentReply({
  content,
  widgets,
  reasoning,
  fromStream,
  onStreamConsumed,
  setArticleIds,
}: Props) {

  useEffect(() => {
    if (!fromStream) return
    onStreamConsumed?.()
  }, [fromStream]) // onStreamConsumed intentionally omitted — one-shot clear

  return (
    <div className='AgentReply'>
      {reasoning && reasoning.length > 0 && (
        <div className='Reasoning'>
          {reasoning}
        </div>
      )}
      <MarkdownViewer value={content} />
      {widgets && widgets.length > 0 && (
        <div className='Widgets'>
          {widgets.map((widget, index) => (
            <div
              key={`${widget.placeholder}-${index}`}
              className='Widget'
            >
              <AgentWidgetView
                widget={widget}
                fromStream={fromStream}
                setArticleIds={setArticleIds}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
